import { Cluster } from 'components/Kubernetes/types/cluster';

export enum ActionTypes {
  SET_LIST = 'cluster: set-list',
}

export interface IClusterState {
  list: Array<Cluster>;
}
